import React, { useState } from 'react'
import { FieldRenderProps } from 'react-final-form'
import { Input as StyledInput, PasswordRevealButton, FieldIcon } from './styles'
import { InputData, Html } from './type'
import Icon from '../../Icon'

interface Props extends FieldRenderProps<string, HTMLElement> {
  id: string
  data: InputData
  html: Html
}


const Password: React.FC<Props> = ({
  id,
  input,
  data,
  html = {
    maxLength: 255,
  },
}) => {
  const [showPassword, setShowPassword] = useState(false)

  return (
    <>
      {data.icon && (
        <FieldIcon>
          <Icon
            name={data.icon}
          />
        </FieldIcon>
      )}

      <StyledInput
        id={id}
        {...input}
        {...html}
        type={showPassword ? 'text' : 'password'}
      />

      <PasswordRevealButton
        type="button"
        onClick={() => setShowPassword(prev => !prev)}
      >
        <Icon
          name="eye"
        />
      </PasswordRevealButton>
    </>
  )
}

export default Password
